var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score"},[_vm._v(_vm._s(_vm.$t('QUESTION_FORM.YOUR_SCORE'))+" "+_vm._s(_vm.userScore)+" / "+_vm._s(_vm.totalScore))])
}
var staticRenderFns = []

export { render, staticRenderFns }